module.exports = __webpack_public_path__ + "img/banner_products.1e57e619.png";